import { render } from "./SettingsCard.vue?vue&type=template&id=1c5b48f8"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__